<template>
  <div class="c-list-box">
    <ul class="c-list-nav">
      <li class="c-list-title" title="Essential">专项附加扣除管理</li>
      <el-button
        type="primary"
        :icon="Download"
        link
        @click="state.showAgent = true"
        v-if="$judge_auth('21')"
      >
        从税局更新指定扣缴义务人数据
      </el-button>
      <el-button
        type="success"
        :icon="Download"
        link
        @click="state.showAgentEmployee = true"
        v-if="$judge_auth('21')"
      >
        从税局更新指定员工数据
      </el-button>
      <el-button
        type="warning"
        link
        icon="Tickets"
        @click.stop="
          state.key = Math.random();
          state.showLog = true;
        "
        v-if="$judge_auth('22')"
      >
        操作记录
      </el-button>
      <el-button
        type="primary"
        :icon="Upload"
        link
        @click="onExport"
        v-if="$judge_auth('689')"
        size="large"
        >导出
      </el-button>
    </ul>
    <ul class="c-list-search">
      <el-date-picker
        v-model="state.params.skssq"
        type="month"
        placeholder="税款所属月份"
        value-format="YYYYMM"
        format="YYYY年M月"
        :clearable="false"
        style="width: 160px"
      />
      <div
        class="c-withholdingagent-search-box"
        @click="state.showWithholdingAgent = true"
      >
        <li style="flex: 1; display: flex; column-gap: 5px">
          <template v-if="state.withholding_agent_arr?.length > 0">
            <div
              class="c-withholdingagent-search-tag"
              style="
                max-width: 200px;
                overflow: hidden;
                text-overflow: ellipsis;
              "
            >
              {{ state.withholding_agent_arr[0]?.name }}
            </div>
            <el-popover
              v-if="state.withholding_agent_arr?.length > 1"
              placement="right"
              width="auto"
              popper-style="max-height: 90vh;overflow-y: auto;"
            >
              <template #reference>
                <div class="c-withholdingagent-search-tag" @click.stop="">
                  {{ "+ " + (state.withholding_agent_arr?.length - 1) }}
                </div>
              </template>
              <template #default>
                <div
                  style="
                    display: flex;
                    flex-direction: column;
                    row-gap: 5px;
                    width: fit-content;
                  "
                >
                  <ul
                    v-for="(item, index) in state.withholding_agent_arr"
                    :key="item"
                    style="
                      white-space: nowrap;
                      background-color: #f0f2f5;
                      color: var(--el-color-info);
                      border-radius: 4px;
                      font-size: 12px;
                      padding: 0 9px;
                      height: 24px;
                      line-height: 24px;
                      display: flex;
                      align-items: center;
                      column-gap: 10px;
                    "
                  >
                    <li>{{ item.name }}</li>
                    <el-icon
                      @click.stop="state.withholding_agent_arr.splice(index, 1)"
                      color="#a2a2a2"
                      style="cursor: pointer"
                      ><CircleClose
                    /></el-icon>
                  </ul>
                </div>
              </template>
            </el-popover>
          </template>
          <text v-else style="color: #a2a2a2">点击选择扣缴义务人</text>
        </li>
        <el-icon
          v-if="state.withholding_agent_arr?.length > 0"
          @click.stop="delete state.withholding_agent_arr"
          color="#a2a2a2"
          ><CircleClose
        /></el-icon>
      </div>
      <el-select
        v-model="state.params.tax_bureau_id"
        placeholder="税局"
        style="width: 300px"
      >
        <el-option
          v-for="item in state.taxbureau_data"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        />
        <template #footer>
          <el-button size="small" @click="onLoadTaxBureau()"> 刷新 </el-button>
        </template>
      </el-select>
      <el-select
        v-model="state.params.customer_id"
        placeholder="所属客户"
        style="width: 300px"
      >
        <el-option
          v-for="item in state.customerData"
          :key="item.id"
          :label="item.alias + '(' + item.name + ')'"
          :value="item.id"
        />
        <template #footer>
          <el-button size="small" @click="onLoadCustomer()"> 刷新 </el-button>
        </template>
      </el-select>
      <el-input
        v-model="state.params.keywords"
        style="width: 200px"
        placeholder="姓名、证件号、手机号"
        clearable
        @clear="
          delete state.params.keywords;
          onLoad();
        "
        @paste.enter="$onKeywordsPaste($event, state.params)"
      ></el-input>
      <el-dropdown split-button @click="onLoad" type="primary">
        查询
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item :icon="RefreshLeft" @click="onReset()">
              重置
            </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </ul>
    <ul class="c-list-table">
      <el-table
        ref="tableDom"
        :data="state.tableData"
        v-loading="!Array.isArray(state.tableData)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
        @sort-change="onSortChange"
        @row-click="onRowClick"
        size="large"
      >
        <el-table-column
          fixed
          label="序号"
          width="50"
          type="index"
          :index="
            (index) => (state.params.page - 1) * state.params.limit + index + 1
          "
          align="center"
        />
        <el-table-column
          prop="xm"
          label="姓名"
          :formatter="$tab_TextFormat"
          min-width="120"
          fixed
        />
        <el-table-column
          prop="zzhm"
          label="证件号"
          :formatter="$tab_TextFormat"
          min-width="180"
        >
          <template #default="{ row }">
            <text
              style="color: #1e90ff"
              class="text-hover-decoration"
              title="证件号"
              @click="$onCopy(row.zzhm)"
            >
              {{ row.zzhm }}
            </text>
          </template>
        </el-table-column>
        <el-table-column
          prop="update_time"
          label="更新时间"
          :formatter="$tab_TextFormat"
          min-width="180"
        />
        <el-table-column
          prop="withholding_agent_name"
          label="扣缴义务人"
          :formatter="$tab_ShowToolTip"
          min-width="220"
        />
        <el-table-column
          prop="unified_social_credit_identifier"
          label="统一社会信用代码"
          :formatter="$tab_TextFormat"
          min-width="180"
        >
          <template #default="{ row }">
            <text
              style="color: #1e90ff"
              class="text-hover-decoration"
              title="统一社会信用代码"
              @click="$onCopy(row.unified_social_credit_identifier)"
            >
              {{ row.unified_social_credit_identifier }}
            </text>
          </template>
        </el-table-column>
        <el-table-column
          prop="tax_bureau_name"
          label="税局"
          :formatter="$tab_ShowToolTip"
          min-width="260"
        />
        <el-table-column
          prop="skssq"
          label="税款所属月份"
          :formatter="$tab_TextFormat"
          align="center"
          width="120"
        />
        <el-table-column
          prop="znjyzc"
          label="子女教育"
          :formatter="$tab_PriceFormat"
          align="right"
          width="120"
        />
        <el-table-column
          prop="jxjyzc"
          label="继续教育"
          :formatter="$tab_PriceFormat"
          align="right"
          width="120"
        />
        <el-table-column
          prop="zfzjzc"
          label="住房租金"
          :formatter="$tab_PriceFormat"
          align="right"
          width="120"
        />
        <el-table-column
          prop="sylrzc"
          label="赡养老人"
          :formatter="$tab_PriceFormat"
          align="right"
          width="120"
        />
        <el-table-column
          prop="yyezhzc"
          label="3岁以下婴幼儿照顾"
          :formatter="$tab_PriceFormat"
          align="right"
          width="140"
        />
        <el-table-column
          prop="ljznjyzc"
          label="累计子女教育"
          :formatter="$tab_PriceFormat"
          align="right"
          width="120"
        />
        <el-table-column
          prop="ljjxjyzc"
          label="累计继续教育"
          :formatter="$tab_PriceFormat"
          align="right"
          width="120"
        />
        <el-table-column
          prop="ljzfdklxzc"
          label="累计住房贷款利息"
          :formatter="$tab_PriceFormat"
          align="right"
          width="140"
        />
        <el-table-column
          prop="ljzfzjzc"
          label="累计住房租金"
          :formatter="$tab_PriceFormat"
          align="right"
          width="120"
        />
        <el-table-column
          prop="ljsylrzc"
          label="累计赡养老人"
          :formatter="$tab_PriceFormat"
          align="right"
          width="120"
        />
        <el-table-column
          prop="ljyyezhzc"
          label="累计3岁以下婴幼儿照顾"
          :formatter="$tab_PriceFormat"
          align="right"
          width="170"
        />
        <el-table-column
          label="操作"
          width="120"
          align="center"
          fixed="right"
          v-if="$judge_auth('23')"
        >
          <template #default="{ row }">
            <el-button
              type="primary"
              link
              icon="Search"
              @click.stop="
                $store.commit('openMenu', {
                  path: 'EssentialDetail',
                  refresh: true,
                  title: row.xm + '-专项附加扣除明细',
                  data: {
                    id: row.id,
                    employee_id: row.employee_id,
                  },
                })
              "
            >
              详情
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </ul>
    <transition name="el-zoom-in-center">
      <c_popup
        v-if="state.showAgent"
        title="从税局更新指定扣缴义务人专项附加扣除"
        @close="state.showAgent = false"
      >
        <c_Agent
          :skssq="state.params.skssq"
          v-if="state.showAgent"
          @close="state.showAgent = false"
        ></c_Agent>
      </c_popup>
    </transition>
    <transition name="el-zoom-in-center">
      <c_popup
        v-if="state.showAgentEmployee"
        title="从税局更新指定员工专项附加扣除"
        @close="state.showAgentEmployee = false"
      >
        <c_AgentEmployee
          :skssq="state.params.skssq"
          v-if="state.showAgentEmployee"
          @close="state.showAgentEmployee = false"
        ></c_AgentEmployee>
      </c_popup>
    </transition>
    <el-drawer
      v-model="state.showLog"
      destroy-on-close
      title="操作记录"
      size="70%"
    >
      <c_EssentialLog></c_EssentialLog>
    </el-drawer>
    <transition name="el-zoom-in-center">
      <c_popup
        v-if="state.showWithholdingAgent"
        title="选择扣缴义务人"
        @close="state.showWithholdingAgent = false"
      >
        <c_WithholdingAgentSelect
          @close="
            (arr) => {
              state.withholding_agent_arr = arr;
              state.showWithholdingAgent = false;
            }
          "
          :selectItems="state.withholding_agent_arr"
        ></c_WithholdingAgentSelect>
      </c_popup>
    </transition>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import {
  data_withholdingagent_select,
  data_customer_select,
  data_taxbureau_select,
} from "@/http/data";
import { essential_list, essential_export } from "@/http/essential";
import { dayjs } from "element-plus";
import { ElMessage } from "element-plus";

import c_Agent from "./SelectWithholdingAgent.vue";
import c_AgentEmployee from "./SelectEmployee.vue";

class InitFormData {
  params = {
    limit: 20,
    page: 1,
  };
}
export default {
  components: {
    c_Agent,
    c_AgentEmployee,
  },
  setup() {
    const tableDom = ref(null);
    const state = reactive(new InitFormData());
    onMounted(() => {
      state.params.skssq = dayjs().subtract(1, "month").format("YYYYMM");

      onLoadWithholdingAgent();
      onLoadCustomer();
      onLoadTaxBureau();
      onLoad();
    });

    const onLoad = () => {
      delete state.tableData;

      if (state.withholding_agent_arr?.length > 0)
        state.params.withholding_agent_id = state.withholding_agent_arr
          ?.map((m) => m.id)
          .join(",");
      else delete state.params.withholding_agent_id;

      essential_list(state.params).then((res) => {
        if (res.status == 200) {
          const { count, list } = res.data.data;

          state.tableData = list;
          state.totalCount = count;
        }
      });
    };

    //获取客户
    const onLoadCustomer = () => {
      data_customer_select().then((res) => {
        if (res.status == 200) state.customerData = res.data.data?.list;
      });
    };

    //加载扣缴义务人
    const onLoadWithholdingAgent = () => {
      data_withholdingagent_select().then((res) => {
        if (res.status == 200)
          state.withholding_agent_data = res.data.data?.list;
      });
    };

    //加载税局
    const onLoadTaxBureau = () => {
      data_taxbureau_select().then((res) => {
        if (res.status == 200) state.taxbureau_data = res.data.data?.list;
      });
    };

    //排序
    const onSortChange = ({ column }) => {
      if (column.order) {
        state.params.sort_field = column.sortable;
        state.params.sort_value = column.order === "ascending" ? "asc" : "desc";
      } else {
        const params = new InitFormData().params;
        state.params.sort_field = params.Order;
        state.params.sort_value = "asc";
      }
      onLoad();
    };

    //重置查询条件
    const onReset = () => {
      Object.assign(state, new InitFormData());
      onLoad();
    };

    //表格行点击事件
    const onRowClick = (row) => {
      tableDom.value.toggleRowSelection(row);
    };

    const onExport = () => {
      let params = JSON.parse(JSON.stringify(state.params));
      params.limit = 0;
      essential_export(params)
        .then((res) => {
          let fileName = decodeURI(
            res.headers["content-disposition"].split("=")[1],
          );

          //通过后台返回 的word文件流设置文件名并下载
          var blob = new Blob([res.data], {
            type: res.data.type,
          });
          var downloadElement = document.createElement("a");
          var href = window.URL.createObjectURL(blob); //创建下载的链接
          downloadElement.href = href;
          downloadElement.download = fileName; //下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); //点击下载
          document.body.removeChild(downloadElement); //下载完成移除元素
          window.URL.revokeObjectURL(href); //释放掉blob对象
        })
        .catch((err) => {
          const fileReader = new FileReader();
          fileReader.readAsText(
            new Blob([err.data], { type: "application/octet-stream" }),
            "utf-8",
          );
          fileReader.onload = () => {
            const msg = JSON.parse(fileReader.result);
            ElMessage.error(msg?.msg);
          };
        });
    };

    return {
      state,
      tableDom,
      onLoad,
      onSortChange,
      onReset,
      onLoadCustomer,
      onLoadWithholdingAgent,
      onLoadTaxBureau,
      onRowClick,
      onExport,
    };
  },
};
</script>
<style scoped></style>
